import React from 'react';
import MenuDashboard from "./Menu";
import "./css/dashboard.css";
import ListeCmd from "./ListeCmd";
import {
    UserOutlined,
    SettingFilled,
    SmileOutlined,
    SyncOutlined,
    LoadingOutlined,
    SolutionOutlined,
} from '@ant-design/icons';

import {Form, Input, Button, Checkbox, Row, Col, Typography, Divider, Steps, Layout, Result} from 'antd';
import HeaderMember from "./HeaderMember";
import {t} from '../../constant/i18n';

const {Title, Text, Link} = Typography;
const {Step} = Steps;
const {Header, Content, Footer, Sider} = Layout;

class OrderMsg extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            id: Number(this.props.match.params.id),
            type: this.props.match.params.type,
        }
    }

    componentDidMount() {
        let url = "/ident/order/" + this.state.id;
        this.setState({
            btnEnd: <Button type="primary" key="console" href={url}>
                {t('orderMsg.backToOrder')}
            </Button>
        })
    }

    renderMsgSwitch(type) {

        switch (type) {
            case 'success':
                var result = <Result
                    status="success"
                    title={t('orderMsg.paymentRegistered')}
                    subTitle={t('orderMsg.paymentRegisteredDesc')}
                    extra={this.state.btnEnd}
                />
                break;
            case 'error':
                var result = <Result
                    status="warning"
                    title={t('orderMsg.paymentRefused')}
                    subTitle={t('orderMsg.paymentRefusedDesc')}
                    extra={this.state.btnEnd}
                />
                break;
            default:
                var result = <Result
                    status="error"
                    title={t('orderMsg.error')}
                    subTitle={t('orderMsg.errorDesc')}
                    extra={this.state.btnEnd}
                />

        }

        return result;
    }


    render() {
        //console.log(this.state.type)
        return (
            <Layout>
                <HeaderMember/>
                <Layout>
                    <MenuDashboard/>
                    <div className="contentBox">
                        {this.renderMsgSwitch(this.state.type)}
                    </div>
                </Layout>
            </Layout>
        );
    }

}

export default OrderMsg;



